module.exports = "#contentLogin{\n    text-align: center;\n}\n\ndiv {\n    margin-bottom: 8px;\n}\n\nbutton{\n    margin: 1px 1px 4px 1px;\n  }\n"